import { Box, Modal, Stack, Typography, useColorScheme } from "@mui/material";
import { MainInput, SuccessButton } from "../index";
import { Constants } from "../../utils/constants";
import { useEffect, useState } from "react";
import { isValidUrls } from "../../utils/stringFormat";

export default function ProjectAddRedirectModal({
    open,
    onClose,
    onFinish,
}) {
    const { mode } = useColorScheme();
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: 300,
        maxWidth: 450,
        bgcolor: 'background.paper',
        border: `1px solid ${Constants.Colors[mode].border}`,
        borderRadius: "8px",
        boxShadow: 24,
        p: "1.5rem",
    };
    const [originalError, setOriginalError] = useState(false);
    const [finalError, setFinalError] = useState(false);
    const [error, setError] = useState("");
    const [disabled, setDisabled] = useState(false);

    useEffect(() => {
        setOriginalError(false);
        setFinalError(false);
        setError("");
        setDisabled(false);
    }, [open]);
    const handleSubmit = (e) => {
        e.preventDefault();
        const data = new FormData(e.currentTarget);
        const original = data.get("original");
        const match = data.get("match");
        var isValid = true;
        if (!isValidUrls(original)) {
            setOriginalError(true);
            isValid = false;
        } else {
            setOriginalError(false);
        }
        if (!isValidUrls(match)) {
            setFinalError(true);
            isValid = false;
        } else {
            setFinalError(false);
        }
        if (original !== null && match !== null && original?.split("\n").length !== match?.split("\n").length) {
            setError("Original and Final URLs must have the same number of lines");
            isValid = false;
        }
        if (!isValid) {
            return;
        }
        setDisabled(true);
        onFinish({ original, match });
    }
    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-project-create-title"
            aria-describedby="modal-project-create-description"
        >
            <Box sx={style}>
                <Typography id="modal-project-create-title"
                    sx={{
                        fontWeight: Constants.Styles.fontWeight.semiBold,
                        fontSize: Constants.Styles.fontSize.lg,
                        lineHeight: Constants.Styles.lineHeight.lg,
                    }}
                >
                    Add new Redirect
                </Typography>
                <Box component={"form"} onSubmit={handleSubmit} noValidate mt={"1.5rem"}>
                    <Stack direction={"column"} spacing={"1.25rem"}>
                        <Stack
                            direction={{
                                xs: "column",
                                sm: "column",
                                md: "row",
                            }}
                            spacing={2}
                            alignItems={"center"}
                            justifyContent={"space-between"}
                        >
                            <MainInput
                                key="original"
                                name="original" type="textarea"
                                placeholder={`Original URLs`}
                                required
                                error={originalError}
                                helperText={originalError ? "Original URL must be a valid URL" : ""}
                            />
                            <MainInput
                                key="match"
                                name="match" type="textarea"
                                placeholder={`Final URLs`}
                                required
                                error={finalError}
                                helperText={finalError ? "Final URL must be a valid URL" : ""}
                            />
                        </Stack>
                        {error && <Typography variant="body1" color="error" sx={{
                            fontSize: Constants.Styles.fontSize.sm,
                            lineHeight: Constants.Styles.lineHeight.sm,
                        }}>
                            {error}
                        </Typography>}
                        <Stack direction={"row"} justifyContent={"flex-end"}>
                            <SuccessButton type="submit" text="Create" size="medium" fullWidth={false} disabled={disabled} isSubmitting={disabled} />
                        </Stack>
                    </Stack>
                </Box>
            </Box>
        </Modal>
    );
}